import { render, staticRenderFns } from "./BizScope.vue?vue&type=template&id=17eec884&scoped=true"
import script from "./BizScope.vue?vue&type=script&lang=js"
export * from "./BizScope.vue?vue&type=script&lang=js"
import style0 from "./BizScope.vue?vue&type=style&index=0&id=17eec884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17eec884",
  null
  
)

export default component.exports